import { render, staticRenderFns } from "./LinkGroup.vue?vue&type=template&id=65431399"
import script from "./LinkGroup.vue?vue&type=script&lang=js"
export * from "./LinkGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports